// extracted by mini-css-extract-plugin
export default {"wrapper":"Edit_wrapper__+0zrT","title":"Edit_title__EhfwR"};